import { Stack } from '@mui/material';

import { Tag } from './tag';

export const Tags = ({ tags }: { tags: Record<string, string> }) => {
  return (
    Object.entries(tags).length > 0 && (
      <Stack
        gap='8px'
        direction='row'
        flexWrap='wrap'
        alignItems='flex-start'
        alignContent='baseline'
      >
        {Object.entries(tags).map((entry) => (
          <Tag
            variant='secondary'
            key={entry[0]}
            content={entry.filter((x) => x).join('=')}
          />
        ))}
      </Stack>
    )
  );
};
